/**
 * Utility per gestione audio nel gioco
 */

const AUDIO_ENABLED_KEY = 'audio_enabled';

/**
 * Inizializza il sistema audio
 * @param {Phaser.Scene} scene - La scena Phaser
 */
export function initAudio(scene) {
	// Il sistema audio è già disponibile tramite scene.sound
	// Non serve inizializzazione particolare, ma possiamo verificare che i suoni siano caricati
	console.log('Audio system initialized');
}

/**
 * Verifica se l'audio è abilitato
 * @returns {boolean} true se audio è abilitato
 */
export function isAudioEnabled() {
	return getAudioEnabled();
}

/**
 * Legge la preferenza audio da localStorage
 * @returns {boolean} true se audio è abilitato (default: true)
 */
export function getAudioEnabled() {
	try {
		const stored = localStorage.getItem(AUDIO_ENABLED_KEY);
		if (stored === null) {
			// Default: audio abilitato
			return true;
		}
		return stored === 'true';
	} catch (e) {
		console.error('Errore lettura preferenza audio:', e);
		return true; // Default: audio abilitato
	}
}

/**
 * Imposta lo stato dell'audio e salva in localStorage
 * @param {boolean} enabled - true per abilitare, false per disabilitare
 */
export function setAudioEnabled(enabled) {
	try {
		localStorage.setItem(AUDIO_ENABLED_KEY, String(enabled));
		console.log('Audio enabled:', enabled);
	} catch (e) {
		console.error('Errore salvataggio preferenza audio:', e);
	}
}

/**
 * Riproduce un suono se l'audio è abilitato
 * @param {Phaser.Scene} scene - La scena Phaser
 * @param {string} key - Chiave del suono (come caricato in preload)
 * @param {object} config - Configurazione opzionale (volume, loop, ecc.)
 */
export function playSound(scene, key, config) {
	if (!scene || !scene.sound) {
		console.warn('Scene o sound system non disponibile');
		return;
	}

	if (!isAudioEnabled()) {
		return; // Audio disabilitato, non riprodurre
	}

	const soundConfig = config || {};
	
	try {
		scene.sound.play(key, soundConfig);
	} catch (e) {
		console.error('Errore riproduzione suono:', key, e);
	}
}
